import React from 'react';
import styled from 'styled-components';
import * as cs from '../components/common/common-styles';
import { APPLY_ERROR_PHASES } from '../components/common/constants';
import { Icon } from 'rsuite';

const ColoredText = styled.div`
  ${cs.textBase}

  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.color};
`;

const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const WarningContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const warningColors = {
  paidLicense: '#f7981c',
  quarterlyReporter: '#1991eb',
}

function LicenseItem({ warningType }) {
  return (
    <RowWrapper>
      <Icon icon="info-circle" size="2x" style={{ color: warningColors[warningType] }} />
      <div style={{ marginLeft: 6 }}>
        {warningType === 'paidLicense' &&
          <>
            <ColoredText color="#f7981c">The assessment for this business ID is up to date.</ColoredText>
            <ColoredText color="#f7981c">For any other questions about your assessment, contact us at xxxxxxxxx.</ColoredText>
          </>
        }
        {warningType === 'quarterlyReporter' &&
          <>
            <ColoredText color="#1991eb">You have been identified as a quarterly assessment reporter.</ColoredText>
            <ColoredText color="#1991eb">The initial assessment will be due in October of 2021.</ColoredText>
          </>
        }
      </div>
    </RowWrapper>
  );
}

export function LicenseWarnings({ warningType }) {
  return (
    <WarningContainer>
      <LicenseItem warningType={warningType} />
    </WarningContainer>
  );
}

function NoParcelForAddress() {
  return (
    <WarningContainer>
      <RowWrapper>
        <img
          src="../../assets/icon-info-blue.svg"
          alt="Blue info icon"
          style={{ marginRight: '6px' }}
        />
        <div>
          <ColoredText color="#1991eb">We cannot find a parcel number based on the address provided.</ColoredText>
          <ColoredText color="#1991eb">Please use the County website link above to look up your parcel number.</ColoredText>
        </div>
      </RowWrapper>
    </WarningContainer>
  );
}

const NoAddress = styled.div`
  margin-top: 40px;
  width: 400px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid rgb(159, 58, 56);
  background-color: rgb(255, 247, 247);
  font-family: 'Lato';
  color: #9f3a38;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 22px;
`;

function NoAddressForParcel() {
  return <NoAddress>Parcel number not found in San Mateo County</NoAddress>;
}

const ERROR_COMPONENT = {
  [APPLY_ERROR_PHASES.NoAPNForProperty]: NoParcelForAddress,
  [APPLY_ERROR_PHASES.NoPropertyForAPN]: NoAddressForParcel,
}

export function PropertyAPNWarnings({ warningType }) {
  if (!APPLY_ERROR_PHASES[warningType]) return null;

  const ErrorComponent = ERROR_COMPONENT[warningType];
  return <ErrorComponent />;
}
